import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";

import withModal from "../withModal";
import FlowVisibleVariablesEdit from "../../client-variable/FlowVisibleVariablesEdit";

import MaterialModal from "../MaterialModal";

const FlowVisibleVariablesModal = ({ modalProps, isOpen }) => {
    const dispatch = useDispatch();
    const hide = () => dispatch(hideModal("FLOW_VISIBLE_VARIABLES"));

    if (!modalProps) {
        return null;
    }

    const scope = modalProps.variableScope ? modalProps.variableScope : null;
    const clientVariables = modalProps.clientVariablesWithValues ? modalProps.clientVariablesWithValues : null;
    const title = `${scope == "CampaignFlow" ? "Variable" : "Offer Code"} Visibility`;

    return scope ? (
        <MaterialModal
            title={title}
            isOpen={isOpen}
            onClose={hide}
            id="flow-visible-variables"
            maxWidth="lg"
            showPrimaryButton={false}
            cancelButtonText="Close"
        >
            <FlowVisibleVariablesEdit clientVariablesWithValues={clientVariables} variableScope={scope} />
        </MaterialModal>
    ) : null;
};

FlowVisibleVariablesModal.propTypes = {
    modalProps: PropTypes.any,
    isOpen: PropTypes.bool,
    // Injected from Redux (ActionCreators)
    hideModal: PropTypes.func,
};

export default withModal(FlowVisibleVariablesModal, "FLOW_VISIBLE_VARIABLES");
